import { ToolbarFieldConfig } from "../../sinister/components/ToolbarSinisterGeneric/ToolbarSinisterGeneric";
import { CASE_STATUS_OPTIONS } from "../constants/caseStatusOptions";

export const fieldsConfig: ToolbarFieldConfig[] = [
	{
		key: "busyImobile",
		label: "Status de imóvel",
		type: "select",
		options: [
			{ value: "ocupado", label: "Ocupado" },
			{ value: "desocupado", label: "Desocupado" },
			{ value: "Todos", label: "Todos" },
		],
		defaultValue: "Todos",
		extraProps: { sx: { minWidth: 160 } },
	},
	{
		key: "typePeriod",
		label: "Tipo período",
		type: "select",
		options: [
			{ value: "criacao", label: "Criação" },
			{ value: "abertura", label: "Abertura" },
			{ value: "limite", label: "Limite" },
		],
		extraProps: { sx: { minWidth: 150 } },
	},
	{
		key: "data",
		label: "Data",
		type: "select",
		options: [
			{ value: "hoje", label: "Hoje" },
			{ value: "anterior", label: "Anterior" },
			{ value: "7", label: "Últimos 7 dias" },
			{ value: "15", label: "Últimos 15 dias" },
			{ value: "30", label: "Últimos 30 dias" },
			{ value: "60", label: "Últimos 60 dias" },
			{ value: "90", label: "Últimos 90 dias" },
			{ value: "ano", label: "Ano Atual" },
			{ value: "mes", label: "Mês Atual" },
			{ value: "periodo", label: "Período", extraProps: { sx: { color: "#a268e4" } } },
		],
		defaultValue: "mes",
		extraProps: { sx: { minWidth: 150 }, size: "small" },
	},
	{
		key: "dataIni",
		label: "Data Inicial",
		type: "date",
		show: (filters) => filters.data === "periodo",
		extraProps: { sx: { minWidth: 150 } },
	},
	{
		key: "dataFim",
		label: "Data Final",
		type: "date",
		show: (filters) => filters.data === "periodo",
		extraProps: { sx: { minWidth: 150 } },
	},
	{
		key: "statusSinister",
		label: "Status Sinistro",
		type: "select",
		options: [
			{ value: "Todos", label: "Todos" },
			{ value: "open", label: "Abertos" },
			{ value: "in_progress", label: "Em Andamento" },
			{ value: "in_analysis", label: "Em Analise" },
			{ value: "finalized", label: "Finalizados" },
			{ value: "pending", label: "Pendentes" },
			{ value: "debts_confession", label: "Confissão de Dívidas" },
			{ value: "canceled", label: "Cancelados" },
			{ value: "monthly_compensation", label: "Indenizados" },
			{ isGroup: true, label: "Acordos" },
			{ value: "preventive", label: "Preventivo", group: "according" },
			{ value: "judicial", label: "Judicial", group: "according" },
			{ value: "extrajudicial", label: "Extrajudicial", group: "according" },
		],
		defaultValue: ["Todos"],
		extraProps: {
			multiple: true,
			sx: { minWidth: 200 },
			renderValue: (selected: string[]) => {
				const labelMap: Record<string, string> = {
					Todos: "Todos",
					open: "Abertos",
					in_progress: "Em Andamento",
					finalized: "Finalizados",
					pending: "Pendentes",
					debts_confession: "Confissão de Dívidas",
					canceled: "Cancelados",
					monthly_compensation: "Indenizados",
					preventive: "Preventivo",
					judicial: "Judicial",
					extrajudicial: "Extrajudicial",
				};
				return selected.map((s) => labelMap[s] || s).join(", ");
			},
		},
		group: "status",
	},
	{
		key: "caseStatus",
		label: "Status da Cobrança",
		type: "select",
		options: [{ value: "Todos", label: "Todos" }, ...CASE_STATUS_OPTIONS],
		defaultValue: "Todos",
		extraProps: { sx: { minWidth: 220 } },
	},
	{
		key: "selectedIdResponsible",
		label: "Responsável",
		type: "autocomplete",
		options: [],
		extraProps: { sx: { minWidth: 200 } },
	},
	{
		key: "filterField",
		label: "Pesquisar por",
		type: "select",
		options: [
			{ value: "documento", label: "Documento" },
			{ value: "nome", label: "Nome" },
		],
		defaultValue: "documento",
		extraProps: { sx: { minWidth: 150 } },
		group: "searchBar",
	},
	{
		key: "textSearch",
		label: "Pesquisar",
		type: "text",
		extraProps: {
			placeholder: "Digite para buscar...",
			sx: { minWidth: 350 },
		},
		group: "searchBar",
	},
];
